import React, { useEffect, useRef, useState } from "react";
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CFormLabel,
  CFormInput,
} from "@coreui/react";
import Select from "react-select";
import moment from "moment";
import CIcon from "@coreui/icons-react";
import { cilCloudDownload, cilPeople } from "@coreui/icons";
import ReactDatePicker from "react-datepicker";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import {
  getExportableBookingOrder,
  getSearchedBookingOrderList,
} from "src/services/booking.services";
import Mapbox from "./Mapbox";
import { BsChevronDoubleDown, BsChevronDoubleUp } from "react-icons/bs";
import { getUsedSearchedPlasticSealList } from "src/services/plastic-seal.services";
import { getSearchAbleRoutes } from "src/services/route.services";
import { getSearchableStoreList } from "src/services/store.services";
import { getActiveCountryList } from "src/services/country.services";
import useTableSort from "src/__custom_hook/useTableSort";
import TableColumnSortIcon from "src/components/Sort/TableColumnSortIcon";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
const CheckDeliveryStatusTable = () => {
  const { sortConfig, setSortConfig, handleClickColumnSort } = useTableSort();

  const [localUser, setLocalUser] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const [visibleXL, setVisibleXL] = useState(false);
  const toaster = useRef();
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [type, setType] = useState("manage");
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [bookingOrderId, setBookingOrderId] = useState("");
  const [transferOrderNo, setTransferOrderNo] = useState("");
  const [sealBag, setSealBag] = useState("");
  const [selectedSealOption, setSelectedSealOption] = useState(null);
  const [sealOptions, setSealOptions] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [selectedFromStoreOption, setSelectedFromStoreOption] = useState(null);
  const [selectedFromLocationCode, setSelectedFromLocationCode] =
    useState(null);
  const [selectedToStoreOption, setSelectedToStoreOption] = useState(null);
  const [selectedToLocationCode, setSelectedToLocationCode] = useState(null);
  const [locationCodeOptions, setLocationCodeOptions] = useState(null);
  const [storeOptions, setStoreOptions] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRouteOption, setSelectedRouteOption] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [sealArray, setSealArray] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [selectedItemData, setSelectedItemData] = useState({});
  const [selectedPriorityOption, setSelectedPriorityOption] = useState(null);
  const [priority, setPriority] = useState("");
  const [priorityOptions, setPriorityOptions] = useState([
    { label: "normal", value: "normal" },
    { label: "emergency", value: "emergency" },
  ]);
  const [bookingOrderSelectedStatus, setBookingOrderSelectedStatus] =
    useState("");
  const [selectAllStatus, setSelectAllStatus] = useState(false);
  const [triRouteName, setTripRouteName] = useState("");
  const [storeDataArray, setStoreDataArray] = useState([]);
  const [bookingOrderStatus, setBookingOrderStatus] = useState("");
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [tripName, setTripName] = useState("");
  useEffect(() => {
    getStatusList();

    if (localUser?.userType === "superAdmin") {
      getActiveCountries();
    }
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      getRouteNameList(null, selectedCountry.value);
      getUsedSealInfo(null, selectedCountry.value);
      getStoreInfo(selectedCountry.value);
    } else {
      getRouteNameList();
      getUsedSealInfo();
      getStoreInfo();
    }
  }, [selectedCountry]);

  const handleSubmit = () => {
    setCurrentPage(1);
    getBookingOrderItem(1);
  };

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const getBookingOrderItem = (page) => {
    const fromDateFormat = fromDate
      ? moment(fromDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "";
    const toDateFomrat = toDate
      ? moment(toDate, "DD/MM/YYYY").format("YYYY-MM-DD")
      : "";
    const params = {
      limit,
      page: page,
      type: "manage",
      bookingOrderId,
      sealBag,
      tripName,
      transferOrderNo,
      fromLocation: fromLocation,
      toLocation: toLocation,
      tripRoute: triRouteName,
      from: fromDateFormat,
      to: toDateFomrat,
      fromTime: fromTime,
      toTime: toTime,
      status: bookingOrderStatus,
      priority,
      country: selectedCountry ? selectedCountry.value : null,
      sort: sortConfig
        .map((config) => `${config.key}:${config.direction}`)
        .join(","),
    };
    setIsLoading(true);
    getSearchedBookingOrderList(params)
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const getStoreInfo = (country = null) => {
    const limit = 10;
    const page = 1;
    getSearchableStoreList({ limit, page, country })
      .then(async (response) => {
        const storeData = response.data;
        setStoreDataArray(storeData);
        let options = [];
        let locationCodeOptions = [];
        storeData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          const codeOption = {
            value: `${element._id}`,
            label: element.locationCode ? element.locationCode : "N/A",
          };
          options.push(option);
          locationCodeOptions.push(codeOption);
        });
        setStoreOptions(options);
        setLocationCodeOptions(locationCodeOptions);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getRouteNameList = (searchString = null, country = null) => {
    const limit = 10;
    const page = 1;
    getSearchAbleRoutes({ searchString, country })
      .then(async (response) => {
        const fetchedRouteData = response.data;
        let options = [];

        fetchedRouteData.forEach((element) => {
          const option = { value: `${element._id}`, label: `${element.name}` };
          options.push(option);
        });

        setRouteOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getStatusList = () => {
    const statusObj = [
      { name: "All", value: "" },
      { name: "CDT", value: "cvit" },
      { name: "Assigned", value: "assigned" },
      { name: "Accepted", value: "driver" },
      { name: "Delivered", value: "delivered" },
      { name: "Rejected", value: "rejected" },
    ];
    let options = [];
    statusObj.forEach((element) => {
      const option = { value: `${element.value}`, label: `${element.name}` };
      options.push(option);
    });
    setStatusOptions(options);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getBookingOrderItem(newPage);
  };

  const handleReset = () => {
    setBookingOrderId("");
    setSealBag("");
    setSelectedSealOption("");
    setTransferOrderNo("");
    setData([]);
    setFromDate("");
    setToDate("");
    setFromTime("");
    setToTime("");
    setTripName("");
    setSortConfig([]);

    setSelectedToStoreOption("");
    setToLocation("");
    setSelectedToLocationCode("");
    setSelectedFromStoreOption("");
    setFromLocation("");
    setSelectedFromLocationCode("");

    setSelectedRouteOption("");
    setTripRouteName("");

    setBookingOrderSelectedStatus("");
    setBookingOrderStatus("");

    setSelectedPriorityOption("");
    setPriority("");
    if (selectedCountry) {
      setSelectedCountry("");
    }
  };

  const handleLocationModal = (item) => {
    console.log(item);
    // const locations = [
    //   {id:1, latitude: 30.3753, longitude: 69.3451, name: "Pakistan", zoom: 0, From:"Dubai Mall",type:"from"},
    //   {id:2, latitude: 30.1798 , longitude: 66.9750, name: "Quetta", zoom: 0, image:truck,From:"Gold Souq",
    //     type:"vehicle",driver:"A. Qadir",vehicleID:"D-23456"},
    //   {id:3, latitude: 25.2048, longitude: 55.2708, name: "Dubai", zoom: 0, From:"Lulu Al Nahda",type:"to"},
    // ];

    const fromStoreObj = {
      id: item.fromLocation._id,
      latitude: item.fromLocation.latitude,
      longitude: item.fromLocation.longitude,
      name: item.fromLocation.name,
      zoom: 0,
    };
    const toStoreObj = {
      id: item.toLocation._id,
      latitude: item.toLocation.latitude,
      longitude: item.toLocation.longitude,
      name: item.toLocation.name,
      zoom: 0,
    };
    const vehicleObj = {
      id: 1,
      latitude: item.driverLocation.lastLocation.latitude,
      longitude: item.driverLocation.lastLocation.longitude,
      name: item.tripAssignedTo.firstName + " " + item.tripAssignedTo.lastName,
      zoom: 0,
    };

    let locations = [];
    if (fromStoreObj.latitude && fromStoreObj.longitude) {
      const latTest =
        isFinite(fromStoreObj.latitude) &&
        Math.abs(fromStoreObj.latitude) <= 90;
      const longTest =
        isFinite(fromStoreObj.longitude) &&
        Math.abs(fromStoreObj.longitude) <= 180;
      if (latTest && longTest) {
        locations.push(fromStoreObj);
      }
    }
    if (toStoreObj.latitude && toStoreObj.longitude) {
      const latTest =
        isFinite(toStoreObj.latitude) && Math.abs(toStoreObj.latitude) <= 90;
      const longTest =
        isFinite(toStoreObj.longitude) && Math.abs(toStoreObj.longitude) <= 180;
      if (latTest && longTest) {
        locations.push(toStoreObj);
      }
    }

    if (vehicleObj.latitude && vehicleObj.longitude) {
      const latTest =
        isFinite(vehicleObj.latitude) && Math.abs(vehicleObj.latitude) <= 90;
      const longTest =
        isFinite(vehicleObj.longitude) && Math.abs(vehicleObj.longitude) <= 180;
      if (latTest && longTest) {
        locations.push(vehicleObj);
      }
    }
    console.log("locations", locations);
    setLocationData(locations);
    setSelectedItemData(item);

    setVisibleXL(!visibleXL);
  };

  const getUsedSealInfo = async (searchedString = null, country = null) => {
    const limit = 10;
    const page = 1;
    getUsedSearchedPlasticSealList({
      limit,
      page,
      searchedString,
      country,
    })
      .then(async (response) => {
        const storeData = response.data;
        let options = [];
        let serialArray = [];

        storeData.forEach((element) => {
          const option = {
            value: `${element._id}`,
            label: `${element.serialNo}`,
          };
          options.push(option);
          serialArray.push(element.serialNo);
        });
        setSealArray(serialArray);
        setSealOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleChangeFromStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedFromStoreOption(selectedOption);
      setFromLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedFromLocationCode({
        value: storeObj._id,
        label: storeObj.locationCode ? storeObj.locationCode : "N/A",
      });
    } else {
      setSelectedFromStoreOption("");
      setFromLocation("");
      setSelectedFromLocationCode(null);
    }
  };

  const handleChangeFromLocationCode = (selectedOption) => {
    if (selectedOption) {
      setSelectedFromLocationCode(selectedOption);
      setFromLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedFromStoreOption({ value: storeObj._id, label: storeObj.name });
    } else {
      setSelectedFromLocationCode("");
      setSelectedFromStoreOption("");
      setFromLocation("");
    }
  };

  const handleChangeToStore = (selectedOption) => {
    if (selectedOption) {
      setSelectedToStoreOption(selectedOption);
      setToLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedToLocationCode({
        value: storeObj._id,
        label: storeObj.locationCode ? storeObj.locationCode : "N/A",
      });
      setSelectedRouteOption({
        value: storeObj?.route?._id,
        label: storeObj?.route?.name,
      });
    } else {
      setSelectedToLocationCode("");
      setSelectedToStoreOption("");
      setToLocation("");
      setSelectedRouteOption("");
    }
  };

  const handleChangeToLocationCode = (selectedOption) => {
    if (selectedOption) {
      setSelectedToLocationCode(selectedOption);
      setToLocation(selectedOption.value);
      const storeObj = storeDataArray.find(
        (x) => x._id === selectedOption.value
      );
      setSelectedToStoreOption({ value: storeObj._id, label: storeObj.name });
      setSelectedRouteOption({
        value: storeObj?.route?._id,
        label: storeObj?.route?.name,
      });
    } else {
      setSelectedToLocationCode("");
      setSelectedToStoreOption("");
      setToLocation("");
      setSelectedRouteOption("");
    }
  };

  const handleChangeRoute = (selectedOption) => {
    if (selectedOption) {
      setSelectedRouteOption(selectedOption);
      setTripRouteName(selectedOption.value);
    } else {
      setSelectedRouteOption("");
      setTripRouteName("");
    }
  };
  const handleOnInputChangeRoute = (searchValue) => {
    const matchingRoutes = routeOptions.filter((route) =>
      route.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    if (matchingRoutes.length <= 0) {
      getRouteNameList(searchValue);
    }
  };

  const handleChangeSeal = (selectedOption) => {
    if (selectedOption) {
      setSelectedSealOption(selectedOption);
      setSealBag(selectedOption.value);
    } else {
      setSelectedSealOption("");
      setSealBag("");
    }
  };

  const handleOnInputChangeSeal = (selectedOption) => {
    const expectedData = sealArray.find((a) => a.includes(selectedOption));
    if (!expectedData) {
      getUsedSealInfo(selectedOption);
    }
  };

  const handleChangeStatus = async (selectedOption) => {
    setSelectAllStatus(false);
    if (selectedOption) {
      setBookingOrderSelectedStatus(selectedOption);
      setBookingOrderStatus(selectedOption.value);
    } else {
      setBookingOrderSelectedStatus("");
      setBookingOrderStatus("");
    }
  };

  const handleChangePriority = (selectedOption) => {
    if (selectedOption) {
      setSelectedPriorityOption(selectedOption);
      setPriority(selectedOption.value);
    } else {
      setSelectedPriorityOption("");
      setPriority("");
    }
  };

  const handleDateChange = (date, identity) => {
    if (!identity) return;
    let formated = moment(date).format("DD/MM/YYYY");
    if (identity === "from") setFromDate(formated);
    if (identity === "to") setToDate(formated);
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
    setFromLocation(null);
    setSelectedFromLocationCode("");
    setSelectedFromStoreOption(null);
    setToLocation(null);
    setSelectedToLocationCode("");
    setSelectedToStoreOption(null);
    setSealBag(null);
    setSelectedSealOption(null);
    setTripRouteName("");
    setSelectedRouteOption(null);
  };

  const exportToExcel = async () => {
    try {
      toast.loading("Preapring downloads....");
      const params = {
        bookingOrderId,
        type,
        sealBag,
        tripName,
        transferOrderNo,
        fromLocation: fromLocation,
        toLocation: toLocation,
        from: fromDate,
        to: toDate,
        fromTime: fromTime,
        toTime: toTime,
        tripRoute: triRouteName,
        priority,
        status: "",
        country: selectedCountry ? selectedCountry?.value : "",
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
      };
      // getExportableBookingOrderForSuperAdmin()
      getExportableBookingOrder(params)
        .then(async (response) => {
          let result = response.data;
          let exportableData = [];

          result.forEach((element) => {
            let obj = {
              BookingOrderId: element.bookingOrderId,
              FromLocation: element?.fromLocation?.name,
              ToLocation: element?.toLocation?.name,
              "Pick Date": element?.pickupDate,
              "Pickup Time": element?.pickupTime,
              SealBag: element?.sealBag?.serialNo,
              Remarks: element?.remarks,
              TransferOrderNo: element.transferOrderNo,
              "Created Date": element?.createdAt,
              "Created By": element.createdById
                ? `${element?.createdById?.firstName} ${element?.createdById?.lastName}`
                : "",
              "Accept or Rejected By": element.orderAcceptRejectById
                ? `${element?.orderAcceptRejectById?.firstName} ${element?.orderAcceptRejectById?.lastName}`
                : "",
              "Trip Created By": element?.tripAssignedBy
                ? `${element?.tripAssignedBy?.firstName} ${element?.tripAssignedBy?.lastName}`
                : "",
              // "Vechicle Id": element?.tripVehicleId,
              "Vechicle Id": element?.tripTagId,
              "Route Name": element?.tripRoute?.name,
              "Route Code": element?.tripRoute?.routeCode,
              "Trip Driver": element?.tripAssignedTo
                ? `${element?.tripAssignedTo?.firstName} ${element?.tripAssignedTo?.lastName}`
                : "",
              Status: element.status,
              priority: element.priority ? element.priority : "normal",
              Country: element?.country?.name,
            };
            exportableData.push(obj);
          });
          const worksheet = XLSX.utils.json_to_sheet(exportableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Booking-Order.xlsx");
          toast.dismiss();
        })
        .catch((error) => {
          toast.dismiss();
          console.log(error);
        });
    } catch (error) {
      toast.dismiss();
      console.log(error);
    }
  };

  useEffect(() => {
    if (sortConfig.length > 0) {
      setCurrentPage(1);
      getBookingOrderItem(1);
    }
  }, [sortConfig]);

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          {/* <CForm> */}
          <div className="position-absolute p-2 top-0 end-0">
            <CButton
              type="button"
              size="sm"
              className="bg-none"
              color="primary"
              onClick={() => setShowAdditionalFields((prev) => !prev)}
            >
              {showAdditionalFields ? (
                <BsChevronDoubleUp size={15} />
              ) : (
                <BsChevronDoubleDown size={15} />
              )}
            </CButton>
          </div>
          <CRow className="mb-1">
            <CCol sm={12} md={3}>
              <CFormLabel htmlFor="bookingOrderId">
                Booking Order ID:
              </CFormLabel>
              <CFormInput
                type="text"
                value={bookingOrderId}
                onChange={(e) => setBookingOrderId(e.target.value)}
                placeholder="example:DD001"
              />
            </CCol>
            <CCol sm={12} md={6}>
              <CRow>
                <CCol sm={5}>
                  <CFormLabel htmlFor="fromLocationCode">
                    From Location Code:
                  </CFormLabel>
                  <Select
                    id="fromLocationCode"
                    value={selectedFromLocationCode}
                    onChange={handleChangeFromLocationCode}
                    options={locationCodeOptions}
                    isClearable={true}
                  />
                </CCol>
                <CCol sm={7}>
                  <CFormLabel htmlFor="fromLocationName">
                    From Location Name:
                  </CFormLabel>
                  <Select
                    id="fromLocationName"
                    value={selectedFromStoreOption}
                    onChange={handleChangeFromStore}
                    options={storeOptions}
                    isClearable={true}
                    // isDisabled={selectedCountry ? false : true}
                  />
                </CCol>
              </CRow>
            </CCol>
            <CCol sm={12} md={3}>
              <CRow>
                <CFormLabel htmlFor="bookingOrderId">From Date:</CFormLabel>
                <CCol sm={7}>
                  <ReactDatePicker
                    showIcon={true}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    onChange={(date) => handleDateChange(date, "from")}
                    value={fromDate}
                  />
                </CCol>
                <CCol sm={5}>
                  <CFormInput
                    type="time"
                    value={fromTime}
                    onChange={(e) => setFromTime(e.target.value)}
                  />
                </CCol>
              </CRow>
            </CCol>
          </CRow>
          <div
            style={{
              maxHeight: showAdditionalFields ? "100%" : "0",
              transition: "max-height 0.5s ease",
            }}
          >
            {showAdditionalFields && (
              <CRow>
                <CCol sm={12} md={3}>
                  <CRow className="mb-1">
                    <CFormLabel htmlFor="bookingOrderId">
                      Transfer Order No.
                    </CFormLabel>
                    <CCol sm={12}>
                      <CFormInput
                        type="text"
                        placeholder="example:DD001"
                        value={transferOrderNo}
                        onChange={(e) => setTransferOrderNo(e.target.value)}
                      />
                    </CCol>
                  </CRow>
                  <CRow className="mb-1">
                    <CFormLabel htmlFor="bookingOrderId">
                      Seal/Bag No.
                    </CFormLabel>
                    <CCol sm={12}>
                      <Select
                        value={selectedSealOption}
                        onChange={handleChangeSeal}
                        onInputChange={handleOnInputChangeSeal}
                        options={sealOptions}
                        isClearable={true}
                      />
                    </CCol>

                    {/* <CCol sm={12}>
                      <CFormInput
                        type="email"
                        id="exampleFormControlInput1"
                        placeholder="example:DD001"
                        value={sealBag}
                        onChange={(e) => setSealBag(e.target.value)}
                      />
                    </CCol> */}
                  </CRow>
                  <CRow className="mb-1">
                    <CCol sm={12} md={12}>
                      <CFormLabel htmlFor="bookingOrderId">
                        Trip Name
                      </CFormLabel>
                      <CFormInput
                        type="text"
                        placeholder="example:DD001"
                        value={tripName}
                        onChange={(e) => setTripName(e.target.value)}
                      />
                    </CCol>
                  </CRow>
                </CCol>

                <CCol sm={12} md={6}>
                  <CRow className="mb-1">
                    <CCol sm={5}>
                      <CFormLabel htmlFor="toLocationCode">
                        To Location Code:
                      </CFormLabel>
                      <Select
                        id="toLocationCode"
                        value={selectedToLocationCode}
                        onChange={handleChangeToLocationCode}
                        options={locationCodeOptions}
                        isClearable={true}
                      />
                    </CCol>
                    <CCol sm={7}>
                      <CFormLabel htmlFor="toLocationName">
                        To Location Name:
                      </CFormLabel>
                      <Select
                        id="toLocationName"
                        value={selectedToStoreOption}
                        onChange={handleChangeToStore}
                        options={storeOptions}
                        isClearable={true}
                      />
                    </CCol>
                  </CRow>
                  <CRow className="mb-1">
                    <CCol sm={5}>
                      <CFormLabel htmlFor="bookingOrderId">
                        Priority:
                      </CFormLabel>
                      <Select
                        value={selectedPriorityOption}
                        onChange={handleChangePriority}
                        options={priorityOptions}
                        isClearable={true}
                        className="text-capitalize"
                      />
                    </CCol>
                    <CCol sm={7}>
                      <CFormLabel htmlFor="bookingOrderId">
                        Route Name:
                      </CFormLabel>
                      <Select
                        value={selectedRouteOption}
                        onChange={handleChangeRoute}
                        onInputChange={handleOnInputChangeRoute}
                        options={routeOptions}
                        isClearable={true}
                      />
                    </CCol>
                  </CRow>
                </CCol>

                <CCol sm={12} md={3}>
                  <CRow className="mb-1">
                    <CFormLabel htmlFor="bookingOrderId">To Date:</CFormLabel>
                    <CCol sm={7}>
                      <ReactDatePicker
                        showIcon={true}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        onChange={(date) => handleDateChange(date, "to")}
                        value={toDate}
                      />
                    </CCol>
                    <CCol sm={5}>
                      <CFormInput
                        type="time"
                        value={toTime}
                        onChange={(e) => setToTime(e.target.value)}
                      />
                    </CCol>
                  </CRow>

                  <CRow className="mb-1">
                    {/* <CFormLabel htmlFor="bookingOrderId">Status:</CFormLabel>
                    <CCol sm={8}>
                      <Select
                        value={bookingOrderSelectedStatus}
                        onChange={handleChangeStatus}
                        options={statusOptions}
                        isClearable={true}
                      />
                    </CCol> */}

                    {localUser && localUser.userType === "superAdmin" && (
                      <CCol sm={7} md={7}>
                        <CFormLabel>Country:</CFormLabel>

                        <Select
                          value={selectedCountry}
                          onChange={handleCountryChange}
                          options={countrySelectOptions}
                          isClearable={true}
                        />
                      </CCol>
                    )}

                    <CCol
                      sm={
                        localUser && localUser.userType === "superAdmin"
                          ? 5
                          : 12
                      }
                    >
                      <CFormLabel htmlFor="bookingOrderId">Status:</CFormLabel>
                      <Select
                        value={bookingOrderSelectedStatus}
                        onChange={handleChangeStatus}
                        options={statusOptions}
                        isClearable={true}
                      />
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            )}
          </div>
          <CRow className="mt-3">
            <div className="d-flex justify-content-end">
              <CButton
                type="submit"
                className="px-5 py-2 me-3"
                onClick={handleSubmit}
              >
                Submit
              </CButton>
              <CButton
                type="submit"
                className="px-5 py-2 me-3 btn-oliveGreen"
                onClick={handleReset}
              >
                Reset
              </CButton>
            </div>
          </CRow>
          {/* </CForm> */}
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Delivery Status
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              <CButton
                color="primary"
                className="float-end"
                onClick={exportToExcel}
              >
                <CIcon icon={cilCloudDownload} />
                Export
              </CButton>
              {/*  
              <CButtonGroup className="float-end me-3">
                {['Day', 'Month', 'Year'].map((value) => (
                  <CButton
                    color="outline-secondary"
                    key={value}
                    className="mx-0"
                    active={value === 'Month'}
                  >
                    {value}
                  </CButton>
                ))}
              </CButtonGroup> */}
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("bookingOrderId")}
                  style={{ cursor: "pointer" }}
                >
                  Booking Order ID{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "bookingOrderId" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("transferOrderNo")}
                  style={{ cursor: "pointer" }}
                >
                  Transfer Order No.{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "transferOrderNo" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("sealBag")}
                  style={{ cursor: "pointer" }}
                >
                  Seal/Bag No.{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "sealBag" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("fromLocation")}
                  style={{ cursor: "pointer" }}
                >
                  From Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "fromLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("toLocation")}
                  style={{ cursor: "pointer" }}
                >
                  To Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "toLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("tripRoute")}
                  style={{ cursor: "pointer" }}
                >
                  Route Name{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "tripRoute" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Priority
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Last Location Update
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="11">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length > 0 ? (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell className="text-center">
                      {item.status == "New" ? (
                        <CButton
                          color="secondary"
                          style={{ color: "white" }}
                          className="text-capitalize"
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status == "rejected" ? (
                        <CButton
                          color="secondary"
                          style={{ color: "white" }}
                          className="text-capitalize"
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status == "driver" ? (
                        <CButton
                          color="warning"
                          style={{ color: "white" }}
                          className="text-capitalize"
                        >
                          Accepted
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status == "delivered" ? (
                        <CButton
                          color="success"
                          style={{ color: "white" }}
                          className="text-capitalize"
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status == "cvit" ? (
                        <CButton color="primary" style={{ color: "white" }}>
                          CDT
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status == "assigned" ? (
                        <CButton
                          color="primary"
                          style={{ color: "white" }}
                          className="text-capitalize"
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.driverLocation && item.status == "driver" ? (
                        <CButton
                          size="sm"
                          color="secondary"
                          onClick={() => handleLocationModal(item)}
                          style={{ color: "white" }}
                        >
                          Show Location
                        </CButton>
                      ) : (
                        ""
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.status == "cvit" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.orderAcceptRejectBy?.avatar
                              ? item?.orderAcceptRejectBy?.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "assigned" ? (
                        <CAvatar
                          size="md"
                          src={
                            item.orderAcceptRejectBy?.avatar
                              ? item.orderAcceptRejectBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "driver" ? (
                        <CAvatar
                          size="md"
                          src={
                            item.tripAssignedTo?.avatar
                              ? item.tripAssignedTo.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "rejected" ? (
                        <CAvatar
                          size="md"
                          src={
                            item.orderAcceptRejectBy?.avatar
                              ? item.orderAcceptRejectBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "delivered" ? (
                        <CAvatar
                          size="md"
                          src={
                            item.tripAssignedTo?.avatar
                              ? item.tripAssignedTo.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                    </CTableDataCell>

                    <CTableDataCell className="text-center">
                      <div>{item.bookingOrderId}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.transferOrderNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.sealBag?.serialNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.fromLocation
                        ? `${item.fromLocation.name} (${item.fromLocation.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.toLocation
                        ? `${item.toLocation.name} (${item?.toLocation?.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      <div>{item?.tripRoute?.name}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      <div>{item?.priority}</div>
                    </CTableDataCell>

                    <CTableDataCell className="text-center">
                      {item.status == "driver"
                        ? item.driverLocation
                          ? new Date(
                              item.driverLocation.updatedAt
                            ).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              second: "numeric",
                            })
                          : ""
                        : ""}
                    </CTableDataCell>
                  </CTableRow>
                ))
              ) : (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="11">
                    No Data Available
                  </CTableDataCell>
                </CTableRow>
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <DeleteModal
        visible={visibleDeleteModal}
        setVisibleDeleteModal={setVisibleDeleteModal}
        // addToast={addToast}
      />
      {/* <CToaster ref={toaster} push={toast} placement="top-end" /> */}
      <CModal size="xl" visible={visibleXL} onClose={() => setVisibleXL(false)}>
        <CModalHeader>
          <CModalTitle>Location</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Mapbox data={locationData} item={selectedItemData} />
        </CModalBody>
      </CModal>
    </>
  );
};

export default CheckDeliveryStatusTable;
